import React, {useState, useEffect } from 'react';
import authService from '../../api-authorization/AuthorizeService'
import axios from 'axios'
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import createCache from '@emotion/cache';

const muiCache = createCache({
    key: 'mui-datatables',
    prepend: true,
});

export default function PlayerProfile({idType, id }) {
    const [token, setToken] = useState();
    const [playerInfo, setPlayerInfo] = useState();
    const apiPath = '/api/ChessPlayers/GetPlayerByID?id=' + id + '&idType=' + idType;

    useEffect(async () => {
        setToken(await authService.getAccessToken());
        var ttt = await authService.getAccessToken();
        var headers = {
            headers: { 'Authorization': `Bearer ${ttt}` }
        }
        axios.get(apiPath, headers).then((response) => {
            setPlayerInfo(response.data);
        }).catch((error) => {
            console.log(JSON.stringify(error));
        });
    }, []); //Runs only on the first render


    return (
        <div className="mt-10 mb-10">
            {playerInfo &&
                <Box sx={{ pt: 1, pb: 1 }}>
                    <Grid container direction="row" rowSpacing={1} columnSpacing={1} align-items="flex-end">
                        <Grid item xs={12} lg={6}>
                            <Card sx={{}}>
                                {/*<CardMedia*/}
                                {/*    sx={{ height: 140 }}*/}
                                {/*    image="/static/images/cards/contemplative-reptile.jpg"*/}
                                {/*    title="green iguana"*/}
                                {/*/>*/}
                                <CardContent>
                                    <Typography gutterBottom variant="h5" component="div" color="text.primary">
                                        FIDE Profile :   {playerInfo.fidePlayerId > 0 ? playerInfo.fideName : idType + id + " has no FIDE ID"}
                                    </Typography>
                                    {/*<Typography variant="body2" color="text.secondary">*/}
                                    {/*    Lizards are a widespread group of squamate reptiles, with over 6,000*/}
                                    {/*    species, ranging across all continents except Antarctica*/}
                                    {/*</Typography>*/}
                                    <table>
                                        <tbody>
                                            <tr>
                                                <td align="right" nowrap="nowrap">Membership</td>
                                                <td align="right" nowrap="nowrap">   :   </td>
                                                <td align="left" nowrap="nowrap">{playerInfo.fidePlayerId > 0 ? (<a href={'https://ratings.fide.com/profile/' + playerInfo.fidePlayerId} target='_blank' rel='noreferrer'>{playerInfo.fidePlayerId +" [" + playerInfo.fideSex + "," + playerInfo.fideBirthday+"]"}</a>) : "N/A"}</td>
                                            </tr>
                                            <tr>
                                                <td align="right" nowrap="nowrap">Country</td>
                                                <td align="right" nowrap="nowrap">   :   </td>
                                                <td align="left" nowrap="nowrap">{playerInfo.fidePlayerId > 0 ?playerInfo.fideCountry : "N/A"}</td>
                                            </tr>
                                            <tr>
                                                <td align="right" nowrap="nowrap">OTB Rating</td>
                                                <td align="right" nowrap="nowrap">   :   </td>
                                                <td align="left" nowrap="nowrap">{playerInfo.fidePlayerId > 0 ? "Regular " + playerInfo.fideRating + " [K" + playerInfo.fidekValue + "] | Blitz " + playerInfo.fideBlitzRating + " [K" + playerInfo.fideBlitzKValue + "] | Rapid " + playerInfo.fideRapidRating + " [K" + playerInfo.fideRapidKValue + "] ": "N/A"}</td>
                                            </tr>
                                            <tr>
                                                <td align="right" nowrap="nowrap">Title</td>
                                                <td align="right" nowrap="nowrap">   :   </td>
                                                <td align="left" nowrap="nowrap">{playerInfo.fidePlayerId > 0 ? playerInfo.fideTitle : "N/A"} {playerInfo.fidePlayerId > 0 ? playerInfo.fideWomenTitle : ""} {playerInfo.fidePlayerId > 0 ? playerInfo.fideOtherTitle : ""}</td>
                                            </tr>

                                        </tbody>
                                    </table>
                                </CardContent>
                                {/*<CardActions>*/}
                                {/*    <Button size="small">Share</Button>*/}
                                {/*    <Button size="small">Learn More</Button>*/}
                                {/*</CardActions>*/}
                            </Card>
                        </Grid>
                        <Grid item xs={12} lg={6}>
                            <Card sx={{}}>
                                {/*<CardMedia*/}
                                {/*    sx={{ height: 140 }}*/}
                                {/*    image="/static/images/cards/contemplative-reptile.jpg"*/}
                                {/*    title="green iguana"*/}
                                {/*/>*/}
                                <CardContent>
                                    <Typography gutterBottom variant="h5" component="div" color="text.primary">
                                        USCF Profile :   {playerInfo.uscfPlayerId > 0 ? playerInfo.uscfName : idType + id + " is Non-USCF"}
                                    </Typography>
                                    {/*<Typography variant="body2" color="text.secondary">*/}
                                    {/*    Lizards are a widespread group of squamate reptiles, with over 6,000*/}
                                    {/*    species, ranging across all continents except Antarctica*/}
                                    {/*</Typography>*/}
                                    <table>
                                        <tbody>
                                            <tr>
                                                <td align="right" nowrap="nowrap">Membership</td>
                                                <td align="right" nowrap="nowrap">   :   </td>
                                                <td align="left" nowrap="nowrap">{playerInfo.uscfPlayerId > 0 ? (<a href={'https://ratings.uschess.org/player/' + playerInfo.uscfPlayerId} target='_blank' rel='noreferrer'>{playerInfo.uscfPlayerId + " [Exp " +playerInfo.uscfExpDate.split("T")[0]+"]"}</a>) : "N/A"}</td>
                                            </tr>
                                            <tr>
                                                <td align="right" nowrap="nowrap">State</td>
                                                <td align="right" nowrap="nowrap">   :   </td>
                                                <td align="left" nowrap="nowrap">{playerInfo.uscfPlayerId > 0 ? playerInfo.uscfState: "N/A"}</td>
                                            </tr>
                                            <tr>
                                                <td align="right" nowrap="nowrap">OTB Rating</td>
                                                <td align="right" nowrap="nowrap">   :   </td>
                                                <td align="left" nowrap="nowrap">{playerInfo.uscfPlayerId > 0 ? "Regular "+playerInfo.uscfRating+" | Blitz "+playerInfo.uscfBlitzRating+" | Quick "+playerInfo.uscfQuickRating : "N/A"}</td>
                                            </tr>
                                            <tr>
                                                <td align="right" nowrap="nowrap">Online Rating</td>
                                                <td align="right" nowrap="nowrap">   :   </td>
                                                <td align="left" nowrap="nowrap">{playerInfo.uscfPlayerId > 0 ? "Regular " + playerInfo.uscfOnlineRating + " | Blitz " + playerInfo.uscfOnlineBlitzRating + " | Quick " + playerInfo.uscfOnlineQuickRating : "N/A"}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </CardContent>
                                {/*<CardActions>*/}
                                {/*    <Button size="small">Share</Button>*/}
                                {/*    <Button size="small">Learn More</Button>*/}
                                {/*</CardActions>*/}
                            </Card>
                        </Grid>
                    </Grid>
                </Box>
                }
        
        </div>
    )
}
